import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReleaseAlert = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "release_alert",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4462_34373",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_4462_34373)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "release_alert_2",
				d: "M8.81147 21.8653L7.02697 18.8578L3.63847 18.1153L3.96922 14.627L1.67322 12L3.96922 9.37301L3.63847 5.88477L7.02697 5.14227L8.81147 2.13477L12 3.48851L15.1885 2.13477L16.973 5.14227L20.3615 5.88477L20.0307 9.37301L22.3267 12L20.0307 14.627L20.3615 18.1153L16.973 18.8578L15.1885 21.8653L12 20.5115L8.81147 21.8653ZM9.44997 19.95L12 18.8693L14.5807 19.95L16 17.55L18.75 16.9193L18.5 14.1L20.35 12L18.5 9.86927L18.75 7.05002L16 6.45002L14.55 4.05002L12 5.13076L9.41922 4.05002L7.99997 6.45002L5.24997 7.05002L5.49997 9.86927L3.64997 12L5.49997 14.1L5.24997 16.95L7.99997 17.55L9.44997 19.95ZM12 16.7308C12.2256 16.7308 12.4166 16.6526 12.573 16.4963C12.7295 16.3398 12.8077 16.1487 12.8077 15.923C12.8077 15.6973 12.7295 15.5063 12.573 15.35C12.4166 15.1937 12.2256 15.1155 12 15.1155C11.7743 15.1155 11.5833 15.1937 11.427 15.35C11.2705 15.5063 11.1922 15.6973 11.1922 15.923C11.1922 16.1487 11.2705 16.3398 11.427 16.4963C11.5833 16.6526 11.7743 16.7308 12 16.7308ZM11.25 13.077H12.75V7.07702H11.25V13.077Z",
				fill: "currentColor"
			})
		})]
	})
});
export default SvgReleaseAlert;
